<template>
  <div>
    <div class="invoice-one">
      <div class="invoiceFrom">
        <el-form :model="invoice"
                 :rules="rules"
                 ref="invoice"
                 size="mini"
                 label-width="100px"
                 class="demo-ruleForm"
                 label-position="top">
          <el-form-item label="发票类型"
                        prop="type">
            <el-radio-group v-model="invoice.type"
                            @change="showRadio">
              <el-radio :label=1>个人</el-radio>
              <el-radio :label=2>企业</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发票类型:"
                        prop="invoice_type">
            <el-select placeholder="请选择发票类型"
                       v-model="invoice.invoice_type"
                       @change="other">
              <el-option v-for="item in invoice_addlist"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value+''">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票抬头:"
                        prop="header">
            <el-input size="small"
                      v-model="invoice.header"
                      placeholder="请输入发票抬头"></el-input>
          </el-form-item>
          <div v-if="geren==1">
            <el-form-item label="纳税人识别码:"
                          prop="taxpayer">
              <el-input size="small"
                        v-model="invoice.taxpayer"
                        placeholder="请输入纳税人识别码"></el-input>
            </el-form-item>

            <div v-if="otherInfo==2">
              <el-form-item label="开户行:"
                            prop="bank_name">
                <el-input size="small"
                          v-model="invoice.bank_name"
                          placeholder="请输入开户行"></el-input>
              </el-form-item>
              <el-form-item label="银行账号:"
                            prop="bank_account">
                <el-input size="small"
                          v-model="invoice.bank_account"
                          placeholder="请输入银行账号"></el-input>
              </el-form-item>
              <el-form-item label="注册地址:"
                            prop="register_address">
                <el-input size="small"
                          v-model="invoice.register_address"
                          placeholder="请输入注册地址"></el-input>
              </el-form-item>
              <el-form-item label="注册电话:"
                            prop="register_tel">
                <el-input size="small"
                          v-model="invoice.register_tel"
                          placeholder="请输入注册电话"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item>
            <div class="flex">
              <div class="sub"
                   @click="saveInvoice('invoice')">保存发票信息</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      geren: 1,
      otherInfo: 1,
      invoice: {
        type: '',
        invoice_type: '',
        header: '',
        taxpayer: '',
        bank_account: '',
        bank_name: '',
        register_address: '',
        register_tel: ''
      },
      invoice_addlist: [],
      rules: {
        type: [
          { required: true, message: '请选择发票类型', trigger: 'change' }
        ],
        invoice_type: [
          { required: true, message: '请选择发票类型', trigger: 'change' }
        ],
        header: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
        taxpayer: [
          { required: true, message: '请输入纳税人识别码', trigger: 'blur' }
        ],
        bank_name: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bank_account: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        register_address: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        register_tel: [
          { required: true, message: '请输入注册电话', trigger: 'blur' }
        ]
      }
    }
  },
  created() {},
  mounted() {
    this.invoice.type = this.data
    if (this.invoice.type == 2) {
      // this.invoice.type = this.data
      this.invoice_addlist = [
        {
          value: 1,
          label: '增值税普通发票'
        },
        {
          value: 2,
          label: '增值税专用发票'
        }
      ]
    } else {
      // this.invoice.type = this.data
      this.invoice_addlist = [
        {
          value: 1,
          label: '增值税普通发票'
        }
      ]
      this.geren = 2
    }
  },
  methods: {
    // 显示隐藏不同发票填写的内容-----下拉框
    other(val) {
      if (val == 1) {
        this.otherInfo = 1
      } else {
        this.otherInfo = 2
      }
    },
    //单选框 个人，企业
    showRadio(i) {
      // this.invoice = {}
      this.invoice = {
        type: i
      }
      if (i == 1) {
        this.geren = 2 //类型为1(个人)的时候，geren为2
        this.invoice_addlist = [
          {
            value: 1,
            label: '增值税普通发票'
          }
        ]
      } else {
        this.invoice_addlist = [
          {
            value: 1,
            label: '增值税普通发票'
          },
          {
            value: 2,
            label: '增值税专用发票'
          }
        ]
        this.geren = 1 //类型为1(个人)的时候，geren为1
      }
    },
    saveInvoice(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api
            .queryInvoice({
              shop_type: 'qycg',
              // access_token: this.$store.state.qycg_user.access_token,
              invoice_type: this.invoice.invoice_type,
              type: this.invoice.type,
              header: this.invoice.header,
              taxpayer: this.invoice.taxpayer,
              bank_account: this.invoice.bank_account,
              bank_name: this.invoice.bank_name,
              register_address: this.invoice.register_address,
              register_tel: this.invoice.register_tel
            })
            .then(res => {
              // console.log(res)
              if (res.code == 0) {
                // this.$parent.invoiceList(this.invoice.type)
                this.$emit('close', this.invoice.type)
                // this.$emit('invoiceList')
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'success',
                  offset: 200,
                  duration: 1000
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'warning',
                  offset: 200,
                  duration: 1000
                })
              }
            })
            .catch(err => {
              // console.log(err);
            })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.invoice-one {
  // width: 1080px;
  // height: 763px;
  margin: -23px auto;
  background: #ffffff;
  // box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  .invoiceFrom {
    width: 100%;
    // padding: 24px 20px 24px 450px;
    box-sizing: border-box;
    // margin: 0 auto;
    padding: 0 74px;

    .flex {
      display: flex;
    }
    .sub {
      cursor: pointer;
      width: 114px;
      height: 32px;
      background: #ff0e25;
      border-radius: 2px;
      color: #fff;
      line-height: 32px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      text-align: center;
    }
  }
}
</style>